export const moduleName = 'author';